import { useTranslation } from 'react-i18next';
import { ViewContext } from 'src/store/user-store';

export const useViewContextName = (
  viewContext: ViewContext | null,
  selectedSite: { name: string } | undefined,
  selectedTenant: { name: string } | undefined,
) => {
  const { t } = useTranslation();

  const getViewContextName = () => {
    switch (viewContext) {
      case 'site':
        return t('common:viewContextSelector.siteWithName', {
          siteName: selectedSite?.name,
        });

      case 'tenant':
        return t('common:viewContextSelector.tenantWithName', {
          tenantName: selectedTenant?.name,
        });

      default:
        return t('common:viewContextSelector.placeholder');
    }
  };

  return getViewContextName;
};
